import React from 'react';
import Head from 'next/head';
import getConfig from 'next/config';

import initPolyglot from '~/src/utilities/libs/polyglot';

import i18n from './twitterTag.i18n.json';
const getTranslation = initPolyglot(i18n);

const {publicRuntimeConfig: config} = getConfig();

const TwitterTag = ({twitterTeaser}) => {
    const twitterTitle = getTranslation(twitterTeaser.titleHeader ? 'titleWithTitleHeader' : 'title', twitterTeaser);
    return (
        <Head>
            <meta key="twitterCard" name="twitter:card" content="summary_large_image" />
            <meta key="twitterSite" name="twitter:site" content={config.socialMedia.twitter.site} />
            <meta key="twitterTitle" name="twitter:title" content={twitterTitle} />
            <meta key="twitterDescription" name="twitter:description" content={twitterTeaser.description} />
            {twitterTeaser?.images?.big?.src && <meta key="twitterImage" property="twitter:image:src" content={twitterTeaser.images.big.src} />}
        </Head>
    );
};

export default TwitterTag;
